"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _chart_utility = require("../../../../packages/common-utilities/src/chart_utility");

var _chart_utility2 = _interopRequireDefault(_chart_utility);

var _collection_utility = require("../../../../packages/common-utilities/src/collection_utility");

var _ramda = require("ramda");

var _date_formatter = require("../../../../packages/common-utilities/src/date_formatter");

var _date_formatter2 = _interopRequireDefault(_date_formatter);

var _formatted_number = require("../global_components/formatted_number");

var _formatted_number2 = _interopRequireDefault(_formatted_number);

var _tracking_utility = require("../../../../packages/common-utilities/src/tracking_utility");

var _number_utility = require("../../../../packages/common-utilities/src/number_utility");

var _number_utility2 = _interopRequireDefault(_number_utility);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ICGrowthOfHypoChart = function (_React$Component) {
    _inherits(ICGrowthOfHypoChart, _React$Component);

    function ICGrowthOfHypoChart(props) {
        _classCallCheck(this, ICGrowthOfHypoChart);

        var _this = _possibleConstructorReturn(this, (ICGrowthOfHypoChart.__proto__ || Object.getPrototypeOf(ICGrowthOfHypoChart)).call(this, props));

        _this.trackChartHover = false;
        return _this;
    }

    _createClass(ICGrowthOfHypoChart, [{
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.stats.length !== this.props.stats.length) {
                this.trackChartHover = false;
            }
        }

        /* eslint-disable*/

    }, {
        key: "createPerformanceChart",
        value: function createPerformanceChart(printWidth) {
            return (0, _chart_utility.generateChart)((0, _chart_utility.generateChartId)("ICGrowthOfHypoChart", printWidth && typeof printWidth === "number"), "linechart", this.props.plotPoints, this.getChartConfiguration(this.props.plotPoints, printWidth));
        }
    }, {
        key: "getChartConfiguration",
        value: function getChartConfiguration(printWidth) {
            var _this2 = this;

            var _props = this.props,
                currencyCode = _props.currencyCode,
                plotPoints = _props.plotPoints,
                dateOption = _props.dateOption,
                initialAmount = _props.initialAmount,
                breakpoint = _props.breakpoint;

            var sortedDataAmount1 = (0, _ramda.sortBy)((0, _ramda.prop)('shareclassAmount1'))(this.props.plotPoints);
            var sortedDataAmount2 = (0, _ramda.sortBy)((0, _ramda.prop)('shareclassAmount2'))(this.props.plotPoints);
            var sortedDataAmount3 = (0, _ramda.sortBy)((0, _ramda.prop)('shareclassAmount3'))(this.props.plotPoints);
            var shareclassMaxTickAmount1 = this.props.disabledIndex[0] ? { shareclassAmount1: null } : sortedDataAmount1[sortedDataAmount1.length - 1];
            var shareclassMinTickAmount1 = this.props.disabledIndex[0] ? { shareclassAmount1: null } : sortedDataAmount1[0];
            var shareclassMaxTickAmount2 = this.props.disabledIndex[1] ? { shareclassAmount2: null } : sortedDataAmount2[sortedDataAmount2.length - 1];
            var shareclassMinTickAmount2 = this.props.disabledIndex[1] ? { shareclassAmount2: null } : sortedDataAmount2[0];
            var shareclassMaxTickAmount3 = this.props.disabledIndex[2] ? { shareclassAmount3: null } : sortedDataAmount3[sortedDataAmount3.length - 1];
            var shareclassMinTickAmount3 = this.props.disabledIndex[2] ? { shareclassAmount3: null } : sortedDataAmount3[0];
            var minYTick = (0, _ramda.apply)(Math.min, [shareclassMinTickAmount1.shareclassAmount1, shareclassMinTickAmount2.shareclassAmount2, shareclassMinTickAmount3.shareclassAmount3]);
            var maxYTick = (0, _ramda.apply)(Math.max, [shareclassMaxTickAmount1.shareclassAmount1, shareclassMaxTickAmount2.shareclassAmount2, shareclassMaxTickAmount3.shareclassAmount3]);
            var xTicks = _chart_utility2.default.getMonthEndsBetweenDates(this.props.plotPoints[0].date, this.props.plotPoints[this.props.plotPoints.length - 1].date, true, false);
            var yTicks = _number_utility2.default.getTicks(minYTick, maxYTick, this.props.plotPoints[0].shareclassAmount1, 6);
            var formattedTicks = _chart_utility2.default.createTicksFormattedInD3DateFormat(xTicks);
            var firstXTick = formattedTicks[0];
            var marginLeft = breakpoint < 4 ? 77 : 85;
            var marginRight = breakpoint < 4 ? 0 : 20;
            var fontSize = "12px";
            var rangePaddingRight = breakpoint < 4 ? "10" : "50";
            var showDateInLongFormat = _collection_utility.CollectionUtility.includes(this.props.formattingRules, 'PERFORMANCE_CHART_SHOW_DATE_IN_MMYYYY');

            var colors = [];
            var values = [];
            var tickerArray = [];
            var disabledIndex = this.props.disabledIndex;
            this.props.stats.forEach(function (stats, index) {
                var disabled = disabledIndex[index];
                tickerArray.push(stats.funds[0].ticker);
                switch (index) {
                    case 0:
                        !disabled && colors.push(disabled ? "#ABADAF" : "#DB5BF0");
                        !disabled && values.push("shareclassAmount1");
                        break;
                    case 1:
                        !disabled && colors.push(disabled ? "#ABADAF" : "#00A16D");
                        !disabled && values.push("shareclassAmount2");
                        break;
                    case 2:
                        !disabled && colors.push(disabled ? "#ABADAF" : "#EB7200");
                        !disabled && values.push("shareclassAmount3");
                        break;
                }
            });

            var formattedDates = _collection_utility.CollectionUtility.reduce(this.props.plotPoints, function (map, value) {
                var date = _date_formatter2.default.getLocalFormattedDateForInjectIntl(value.date, _this2.props.intl);
                map[value.date] = _extends({}, value);
                return map;
            }, {});

            var startDate = d3.timeParse("%Y-%m-%d")(this.props.plotPoints[0].date);
            var endDate = d3.timeParse("%Y-%m-%d")(this.props.plotPoints[this.props.plotPoints.length - 1].date);

            var spec = (0, _ramda.mergeDeepLeft)({
                "selector": "#PerformanceChart",
                "keys": ["date"],
                "values": values,
                "container": {
                    "marginBottom": 50,
                    "marginLeft": marginLeft,
                    "marginRight": marginRight,
                    "rangePaddingRight": rangePaddingRight
                },
                "scaled": true,
                "type": "line",
                "style": {
                    "fill": colors
                },
                "colors": colors,
                "axis": {
                    "x": {
                        "show": true,
                        "tick": {
                            "padding": 5,
                            "values": formattedTicks
                        },
                        "label": {
                            "show": true,
                            "text": function text(d) {
                                if (d === firstXTick && dateOption === 0) {
                                    return "";
                                } else {
                                    return showDateInLongFormat ? _date_formatter2.default.getDateInMonthYearFormatInMMYYYY(d) : _date_formatter2.default.getDateInMonthYearFormat(d);
                                }
                            },
                            "style": {
                                "font-family": "NBInternational",
                                "font-size": fontSize
                            }
                        },
                        "domain": [startDate, endDate]
                    },
                    "y": {
                        "domain": [yTicks[0], yTicks[yTicks.length - 1]],
                        "label": {
                            "show": true,
                            "style": {
                                "font-family": "NBInternational",
                                "font-size": fontSize
                            },
                            "text": function text(d) {
                                if (d <= 0) {
                                    return "";
                                }
                                if (d < 1000000) {
                                    return currencyCode + _formatted_number2.default.prototype.numberFormatter(d3.format(",")(d), _this2.props.numberFormat);
                                }
                                if (d >= 1000000 && d < 1000000000) {
                                    d = d / 1000000;
                                    return currencyCode + _formatted_number2.default.prototype.numberFormatter(d3.format(",.1f")(d), _this2.props.numberFormat) + "M";
                                }
                                if (d >= 1000000000) {
                                    d = d / 1000000000;
                                    return currencyCode + _formatted_number2.default.prototype.numberFormatter(d3.format(",.1f")(d), _this2.props.numberFormat) + "B";
                                }
                            }
                        },
                        "tick": {
                            "padding": 5,
                            "grid": true,
                            "style": {
                                "stroke": "lightgrey"
                            },
                            "values": yTicks
                        },
                        "line": {
                            "show": false
                        }
                    }
                },
                "hoverLine": {
                    "tooltip": {
                        "style": {
                            "font-size": fontSize
                        },
                        "text": function text(data) {
                            if (!_this2.trackChartHover) {
                                _tracking_utility.TrackingUtility.trackEvent({
                                    "eventCategory": 'investment comparison modal',
                                    "eventAction": 'chart',
                                    "eventLabel": _tracking_utility.TrackingUtility.getEventLabel("chartHover")
                                });
                                _this2.trackChartHover = true;
                            }
                            var formattedItem = formattedDates[data.date];
                            var formatteddateDisplay = formattedItem.formattedDate;
                            var dotClass = disabledIndex[0] ? 'ic-ticker-dot-disabled ic-icon' : 'ic-ticker-dot ic-icon';
                            var rectClass = disabledIndex[1] ? 'ic-ticker-rectangle-disabled ic-icon' : 'ic-ticker-rectangle ic-icon';
                            var triClass = disabledIndex[2] ? 'ic-ticker-triangle-disabled ic-icon' : 'ic-ticker-triangle ic-icon';

                            var value1 = disabledIndex[0] ? " <span class='ic-exclaim ic-icon'/>" : " <span class='caption' style='font-weight: 400; vertical-align: middle;'>" + currencyCode + _formatted_number2.default.prototype.numberFormatter(d3.format(",")(data.shareclassAmount1), _this2.props.numberFormat) + "</span>";
                            var value2 = disabledIndex[1] ? " <span class='ic-exclaim ic-icon'/>" : " <span class='caption' style='font-weight: 400; vertical-align: middle;'>" + currencyCode + _formatted_number2.default.prototype.numberFormatter(d3.format(",")(data.shareclassAmount2), _this2.props.numberFormat) + "</span>";
                            var value3 = disabledIndex[2] ? " <span class='ic-exclaim ic-icon'/>" : " <span class='caption' style='font-weight: 400; vertical-align: middle;'>" + currencyCode + _formatted_number2.default.prototype.numberFormatter(d3.format(",")(data.shareclassAmount3), _this2.props.numberFormat) + "</span>";

                            var text = "<div style= 'text-align:left'>";
                            //"#DB5BF0", , ""
                            text += "<div class='caption' style='font-weight:100'>" + formatteddateDisplay + "</div>";
                            text += "<div style= 'text-align:left'> <div class=" + dotClass + " style='width: 16px; height: 16px; vertical-align: middle; display: inline-block;'> </div>  <span class='caption font-regular' style='font-weight: 100; vertical-align: middle;'>" + tickerArray[0] + "</span>" + value1 + "</div>";
                            if (!(0, _ramda.isNil)(tickerArray[1])) {
                                text += "<div style= 'text-align:left'> <div class=" + rectClass + " style='width: 16px; height: 16px; vertical-align: middle; display: inline-block;'> </div>  <span class='caption font-regular' style='font-weight: 100; vertical-align: middle;'>" + ((0, _ramda.isNil)(tickerArray[1]) ? '' : tickerArray[1]) + "</span>" + value2 + "</div>";
                            }
                            if (!(0, _ramda.isNil)(tickerArray[2])) {
                                text += "<div style= 'text-align:left'> <div class=" + triClass + " style='width: 16px; height: 16px; vertical-align: middle; display: inline-block;'> </div>  <span class='caption font-regular' style='font-weight: 100; vertical-align: middle;'>" + ((0, _ramda.isNil)(tickerArray[2]) ? '' : tickerArray[2]) + "</span>" + value3 + "</div>";
                            }
                            if (data.amount === initialAmount && dateOption === 0) {
                                d3.select(".firevis-tooltip").style("display", "none");
                            } else {
                                d3.select(".firevis-tooltip").style("display", "block");
                            }
                            text += "</div>";
                            return text;
                        }
                    }
                }
            }, _chart_utility.COMMON_CHART_CONFIG);

            if (printWidth && typeof printWidth === "number") {
                spec.container.width = (0, _chart_utility.getChartPrintWidth)();
                spec.container.height = (0, _chart_utility.getChartPrintHeight)();
            }

            return spec;
        }
    }, {
        key: "render",
        value: function render() {
            if (this.props.plotPoints.length === 0) {
                return null;
            }
            var performanceChart = this.createPerformanceChart();
            return _react2.default.createElement(
                "div",
                null,
                _react2.default.createElement(
                    "div",
                    null,
                    _react2.default.createElement(performanceChart)
                )
            );
        }
    }]);

    return ICGrowthOfHypoChart;
}(_react2.default.Component);

/* eslint-enable*/


exports.default = ICGrowthOfHypoChart;